import { FilterCategoryEnum, FilterOption } from "@common/utils/graphql";

export const getCustomFieldQueryFilter = (filterOptions: FilterOption[]) => {
  const customFieldEntityObject = filterOptions
    .filter((f) => f.category === FilterCategoryEnum.CustomField)
    .reduce(
      (acc, filterOption) => {
        const customFieldEntityId = Number(filterOption.secondaryId);
        let key: "customFieldListOptionId" | "customFieldBooleanValue";
        let id: number | boolean;
        // This check is to determine if the filter option is a boolean custom field type == Checkbox
        if (filterOption.id == "true" || filterOption.id == "false") {
          key = "customFieldBooleanValue";
          id = filterOption.id == "true";
        } else {
          key = "customFieldListOptionId";
          id = Number(filterOption.id);
        }
        if (!customFieldEntityId) return acc;
        if (
          acc[customFieldEntityId] &&
          acc[customFieldEntityId][key] &&
          Array.isArray(acc[customFieldEntityId][key])
        ) {
          // @ts-expect-error - TS doesn't know that we're checking if the key exists
          acc[customFieldEntityId][key].push(id);
        } else {
          acc[customFieldEntityId] = {
            customFieldEntityId,
            [key]: [id],
          };
        }
        return acc;
      },
      {} as Record<
        number,
        {
          customFieldEntityId: number;
          customFieldListOptionId?: number[];
          customFieldBooleanValue?: boolean[];
        }
      >,
    );
  return Object.values(customFieldEntityObject);
};

const displayFilterCategoryMap = {
  [FilterCategoryEnum.ExpenseCategory]: "Category",
  [FilterCategoryEnum.Department]: "Department",
  [FilterCategoryEnum.Employee]: "Employee",
  [FilterCategoryEnum.ExpenseStatus]: "Expense Status",
  [FilterCategoryEnum.StipendExpenseStatus]: "Expense Status",
  [FilterCategoryEnum.Merchant]: "Merchant",
  [FilterCategoryEnum.PolicyStatus]: "Policy Status",
  [FilterCategoryEnum.ReportStatus]: "Report Status",
  [FilterCategoryEnum.Reviewer]: "Reviewer",
  [FilterCategoryEnum.StipendRule]: "Stipend",
  [FilterCategoryEnum.CustomField]: "Custom Field",
};

export const displayFilterCategory = (category: FilterCategoryEnum) =>
  displayFilterCategoryMap[category];
